import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, Col, Row, Table, Alert } from 'reactstrap';
import { Link } from 'react-router-dom'
import { MdEmail, MdCreate, MdDelete } from 'react-icons/md';
import { Spinner } from 'react-bootstrap';
import ListSystemEmailComponent from '../../../components/Admin/emails/ListSystemEmailComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class SystemEmailPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			listSystemEmail: [],
			checkedEmailIds: [],
			rq_table: {
                per_page: 20,
                page: 0,
                s: '',
                order_by: 'id',
                order: '',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListSystemEmail();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListSystemEmail = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/system-email', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listSystemEmail: ref.data.content.data,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
				});
				this.state.listSystemEmail.forEach( email => {
					email.checked = false;
		        });
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	deleteEmailConFirm = (id) => {
		confirmAlert({
	      	title: '',
	      	message: 'Bạn muốn xóa email này?',
	      	buttons: [
		        {
		          	label: 'Xác nhận',
		          	onClick: () => {
		          		this.deleteEmailRequest(id);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	deleteEmailRequest = (id) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: {id: id}
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/system-email-delete', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
				},
				() => this.getListSystemEmail()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	listSystemEmailRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listSystemEmail.length ) {
                return (
                    this.state.listSystemEmail.map( (email, key) => {
                        return (
                            <ListSystemEmailComponent
	                            key={key}
	                            email={email}
	                            actionKey={key}
	                            delete={ (id) => this.deleteEmailConFirm(id) }
	                            checkedEmail = { (actionKey) => this.checkedEmail(actionKey) }
                                checkedEmailShiftKey = { (actionKey, value) => this.checkedEmailShiftKey(actionKey, value) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getListSystemEmail()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getListSystemEmail()
		)
	}

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getListSystemEmail()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListSystemEmail()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getListSystemEmail()
		)
    }

    checkAll = (e) => {
        let value = e.target.checked;
        let listSystemEmail = this.state.listSystemEmail;
        listSystemEmail.forEach( email => {
            email.checked = value;
        });
        this.setState({
            checkAll: value,
            listSystemEmail: listSystemEmail
        });
        this.checkedEmailIds(listSystemEmail);
    }


    checkedEmail  = (actionKey) => {
        let listSystemEmail = this.state.listSystemEmail;
        listSystemEmail[actionKey].checked = !listSystemEmail[actionKey].checked;
        this.setState({
            listSystemEmail: listSystemEmail,
            checkedStart: actionKey
        });
        this.checkedEmailIds(listSystemEmail);
    }

    checkedEmailShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listSystemEmail = this.state.listSystemEmail;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listSystemEmail[i].checked = value;
            }
            this.setState({
                listSystemEmail: listSystemEmail,
                checkedStart: k
            });
            this.checkedEmailIds(listSystemEmail);
        } else {
            let listSystemEmail = this.state.listSystemEmail;
            listSystemEmail[actionKey].checked = !listSystemEmail[actionKey].checked;
            this.setState({
                listSystemEmail: listSystemEmail,
                checkedStart: actionKey
            });
            this.checkedEmailIds(listSystemEmail);
        }
    }

    checkedEmailIds = (listSystemEmail) => {
    	let checkedEmailIds = [];
    	listSystemEmail.forEach( email => {
    		if (email.checked) {
    			checkedEmailIds.push(email.id)
    		}
        });
        this.setState({
        	checkedEmailIds: checkedEmailIds
        })
    }

    deleteEmails = () => {
    	if (this.state.checkedEmailIds.length) {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn muốn xóa các email này?',
		      	buttons: [
			        {
			          	label: 'Xác nhận',
			          	onClick: () => { this.deleteEmailsRequest() }
			        },
			        {
			          	label: 'Hủy',
			          	onClick: () => false
			        }
		      	]
		    });
    	} else {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn chưa chọn mục cần xóa?',
		      	buttons: [
			        {
			          	label: 'OK',
			          	onClick: () => false
			        }
		      	]
		    });
    	}
    }

    deleteEmailsRequest = () => {

    	let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: {ids: this.state.checkedEmailIds}
		}

		axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/system-email-multi-delete', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					checkedEmailIds: [],
				},
				() => this.getListSystemEmail()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
    }

	render() {
		return (
			<>
                <Breadcrumb title={"System Email"} page={"System Email"} icon={<MdEmail className="breadcrumb-icon" />} />

                <Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
					<Col sm={12}>
						<Link 
							className={`btn btn-primary btn-sm mb-3`}
							to={'/admin/system-email/create' }

						>
							<MdCreate /> Thêm Email
						</Link>
						<button
							className={`btn btn-${this.state.checkedEmailIds.length ? 'danger' : 'outline-danger'} btn-sm mb-3 mx-2 `}
							onClick={ () => this.deleteEmails() }
						>
							<MdDelete /> Xóa email
						</button>
					</Col>
				</Row>

                <Card  className="table-responsive">
                    <Table className="table table-sm table-bordered table-hover rounded text-center">
                        <thead className="primary">
                            <tr>
                            	<th className="text-center" width="3%">
                            		<input
							          	type="checkbox"
							          	defaultValue={false}
							          	onChange={ this.checkAll }
							        />
                            	</th>
                                <th className={'text-center'} width="20%">Tên</th>
                                <th className={'text-center'} width="38%">Tiêu đề</th>
                                <th className={'text-center'} width="30%">Loại</th>
                                <th className={'text-center'} width="10%">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.listSystemEmailRow() } 
                        </tbody>
                    </Table>
                    { this.paginate() }
                </Card>
            </>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminEmail' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemEmailPage);